// extracted by css-extract-rspack-plugin
export default {"lattice":"lattice-kCY56F","cell":"cell-LJKvYX"};